// extracted by mini-css-extract-plugin
module.exports = {"powerstream-cooperation-G":"G_powerstream-cooperation-G__x79vv"};